export const PLANO_CONTA_TIPO_GRUPO_ENUM = [
    {
        id: 'D',
        descricao: "Despesa"
    },
    {
        id: 'R',
        descricao: "Receita"
    }
];